﻿import { Decorators, LookupEditorBase, LookupEditorOptions } from "@serenity-is/corelib";

@Decorators.registerEditor("Matrix.Data.ViewLookupEditor")
export class ViewLookupEditor extends LookupEditorBase<ViewLookupEditorOptions, any> {

    constructor(props: { element?: any } & ViewLookupEditorOptions) {
        super(props);
    }

    protected getLookupKey() {
        return "ViewLookup." + this.options.viewName;
    }
}

export interface ViewLookupEditorOptions extends LookupEditorOptions {
    viewName: string;

}
